import type { MyLocale } from "@i18n";
import Paper from "@mui/material/Paper";
import { useI18n } from "next-rosetta";

import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@components/Table";

import { useAppSelector } from "@store/hooks";
import { contractMigrationRequired } from "@store/selectors/contract";
import { useMemo } from "react";
import NodeListRow from "./NodeListRow";

export default function NodeList({ checkRowSelection, nodes, onRowClick }) {
	const i18n = useI18n<MyLocale>();
	const isMigrationRequired = useAppSelector(contractMigrationRequired);

	return useMemo(
		() => (
			<TableContainer component={Paper} sx={{ backgroundImage: "unset" }}>
				<Table
					sx={{ backgroundImage: "unset", minWidth: 700 }}
					aria-label="node list table"
				>
					<TableHead>
						<TableRow>
							<TableCell padding="checkbox">
								{/* <Checkbox
                  color="primary"
                  indeterminate={numSelected > 0 && numSelected < rowCount}
                  checked={rowCount > 0 && numSelected === rowCount}
                  onChange={onSelectAll}
                  inputProps={{
                    "aria-label": "select all nodes",
                  }}
                  sx={{
                    color: "white",
                    "&.Mui-checked": {
                      color: "white",
                    },
                    "&.MuiCheckbox-indeterminate": {
                      color: "white",
                    },
                  }}
                /> */}
							</TableCell>
							<TableCell>{i18n.t("nodes.nodeListTable.name")}</TableCell>
							<TableCell align="right">
								{i18n.t("nodes.nodeListTable.amount")}
							</TableCell>
							<TableCell align="right">
								{i18n.t("nodes.nodeListTable.lastClaim")}
							</TableCell>
							{!isMigrationRequired && (
								<TableCell align="right">
									{i18n.t("nodes.nodeListTable.rewards")}
								</TableCell>
							)}
							<TableCell align="right" />
						</TableRow>
					</TableHead>
					<TableBody>
						{nodes?.map((node) => (
							<NodeListRow
								key={
									isMigrationRequired
										? node.creationTime.toString()
										: node.creation.toString()
								}
								node={node}
								onRowClick={onRowClick}
								checkRowSelection={checkRowSelection(node.__id)}
							/>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		),
		[nodes, onRowClick, checkRowSelection, i18n, isMigrationRequired],
	);
}
